import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from 'yup';
import { useFormik } from 'formik';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';
import { useTranslation } from 'react-i18next';
import {
  addNewGroup as onAddNewGroup,
  updateGroup as onUpdateGroup,
} from 'store/actions';

import { BillingName, Total, PaymentStatus, PaymentMethod } from './LocationCol';
import { useMutation, useQueryClient } from 'react-query';
//redux
import { useDispatch } from 'react-redux';
// import GroupsModal from './GroupsModal';

import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import { getAllGroupApi } from 'api/group';
import { useRole } from 'hooks/useRole';
import { getSearchColumns, getUserAddress, sumArray } from 'utils/tools';
import { getGroupStatusCountsApi, searchWardsApi, getAllCountiesByRegionApi, getConstituencyApi, getAllRegionsApi, searchConstituencyApi, getWardByIdApi, getCountyByIdApi, getRegionByIdApi, getConstituencyByIdApi, addWard, updateWard } from 'api/report';

import MainFilter from 'components/Common/MainFilter';
import { delApi } from 'api/crud';
import { allowedEmails } from 'configs/constants';
import { SelectField } from 'components/Common/fields';
import StatCards from 'components/Common/StatCards';
import notify from 'utils/notify';

function Group() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [pages, setPages] = useState(0);
  const [id, setId] = useState(null);
  const [, setLoading] = useState(false);
  const { t } = useTranslation();

  const {
    isFacilitator,
    isSiteCord,
    isCountyCoordinator,
    isClusterLeader,
    isFinance,
    isDirector,
    isAdmin,
    isSuperAdmin,
    addresses,
  } = useRole();

  const { mutate: mutateGroupCounts, data: groupSummary } = useMutation(
    (payload) => getGroupStatusCountsApi(payload),
    {
      onSettled: () => {
        queryClient.invalidateQueries('report/group/counts');
      },
    },
  );

  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    sortBy: 'id',
    ascendingSort: false,
    wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
    searchColumns: [
      ...(isFacilitator && (!allowedEmails.includes(localStorage.getItem('shofco_email')))
        ? [
          // {
          //   name: 'wardId',
          //   value: addresses[0]?.wardId,
          // },
        ]
        : []),
      ...(isCountyCoordinator
        ? [
          {
            name: 'countyId',
            value: addresses[0]?.countyId,
          },
        ]
        : []),
      ...(isClusterLeader
        ? [
          {
            name: 'regionId',
            value: addresses[0]?.regionId,
          },
        ]
        : []),
      ...(isSiteCord
        ? [
          {
            name: 'constituencyId',
            value: addresses[0]?.constituencyId,
          },
        ]
        : []),
    ],
  });

  const {
    mutate: mutateGroups,
    isLoading: isLoadingGroups,
    data: groupsData,
  } = useMutation((payload) => searchWardsApi(payload), {
    onSuccess: (res) => {
      res.pages > 0 && setPages(res.pages);
    },
    onSettled: () => {
      setLoading(false);
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const groupsCardData = [
    {
      title: 'Total Counties',
      iconClass: 'bx bx-group',
      description:
        sumArray(groupSummary?.data, 'totalGroups').toLocaleString() || 0,
    },
    {
      title: 'Total Constituencies',
      iconClass: 'bx bx-trophy',
      description:
        sumArray(groupSummary?.data, 'totalActiveGroups').toLocaleString() || 0,
    },
    {
      title: 'Total Wards',
      iconClass: 'bx bx-dislike',
      description:
        sumArray(groupSummary?.data, 'totalInactiveGroups').toLocaleString() ||
        0,
    },
  ];

  //meta title
  document.title = 'Wards | SUN Welfare Administration System';

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [order, setGroup] = useState(null);

  const {
    mutate: mutateWard,
    isLoading: isLoadingWard,
    data: ward,
  } = useMutation((payload) => getWardByIdApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const {
    mutate: mutateConstituency,
    isLoading: isLoadingConstituency,
    data: constituency,
  } = useMutation((payload) => getConstituencyByIdApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const {
    mutate: mutateCounty,
    isLoading: isLoadingCounty,
    data: county,
  } = useMutation((payload) => getCountyByIdApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });
  const {
    mutate: mutateRegion,
    isLoading: isLoadingRegion,
    data: region,
  } = useMutation((payload) => getRegionByIdApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const { mutate: mutateRegions, isLoading: isLoadingRegions,
    data: regions, } = useMutation(
      (payload) => getAllRegionsApi(payload),
      {
        onSuccess: (res) => {
          // let countyIds = addresses?.map((r) => r?.countyId);
          // Step 1: Collect all new data that isn't already in the state
          // const newData = res
          //   ?.filter((r) => countyIds?.includes(r.id))
          //   ?.filter((c) => !counties.some((item) => item.id === c.id));

          // Step 2: Only update the state if there's new data to add
          // if (newData?.length > 0) {
          //   setCounties((prevData) => [...prevData, ...newData]);
          // }
        },
        onSettled: () => {
          queryClient.invalidateQueries('get-all-counties');
        },
      },
    );


  const { mutate: mutateCounties, isLoading: isLoadingCounties,
    data: counties, } = useMutation(
      (payload) => getAllCountiesByRegionApi(payload),
      {
        onSuccess: (res) => {
          // let countyIds = addresses?.map((r) => r?.countyId);
          // Step 1: Collect all new data that isn't already in the state
          // const newData = res
          //   ?.filter((r) => countyIds?.includes(r.id))
          //   ?.filter((c) => !counties.some((item) => item.id === c.id));

          // Step 2: Only update the state if there's new data to add
          // if (newData?.length > 0) {
          //   setCounties((prevData) => [...prevData, ...newData]);
          // }
        },
        onSettled: () => {
          queryClient.invalidateQueries('get-all-counties');
        },
      },
    );

  const { mutate: mutateConstituencies, isLoading: isLoadingConstituencies,
    data: constituencies, } = useMutation(
      (payload) => getConstituencyApi(payload),
      {
        onSuccess: (res) => {
          // let countyIds = addresses?.map((r) => r?.countyId);
          // Step 1: Collect all new data that isn't already in the state
          // const newData = res
          //   ?.filter((r) => countyIds?.includes(r.id))
          //   ?.filter((c) => !counties.some((item) => item.id === c.id));

          // Step 2: Only update the state if there's new data to add
          // if (newData?.length > 0) {
          //   setCounties((prevData) => [...prevData, ...newData]);
          // }
        },
        onSettled: () => {
          queryClient.invalidateQueries('get-all-counties');
        },
      },
    );

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: ward?.name || '',
      constituencyId: ward?.constituencyId || '',
      countyId: constituency?.countyId || '',
      regionId: county?.regionId || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Please Enter  Ward Name'),
      constituencyId: Yup.string().required('Please Select  Constituency'),
      countyId: Yup.string().required('Please Select county'),
      regionId: Yup.string().required('Please Select region'),
    }),
    onSubmit: async (values) => {
      let resp;
      const updateGroup = {
        ...ward,
        name: values.name,
        constituencyId: values.constituencyId
      };
      if (isEdit) {
        // update order
        resp = await updateWard(updateGroup);
      } else {
        // save new order
        resp = await addWard(updateGroup);
      }
      if (resp.status === 'Success') {
        validation.resetForm();
        toggle();
        notify.success('Ward saved successfully');
      } else {
        // Handle error case if needed
        notify.error('Error saving group', resp.message || 'An error occurred. Please try again later.');
      }
      mutateGroups({
        ...pagination,
        pageNumber: pagination.pageNumber - 1,
        wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
      });
    },
  });

  const toggleViewModal = () => setModal1(!modal1);

  useEffect(() => {
    mutateGroups({
      ...pagination,
      pageNumber: pagination.pageNumber - 1,
      wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
    });
  }, [pagination]);

  useEffect(() => {
    const address = getUserAddress();
    mutateGroupCounts({
      wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
      address: address == null ? {} : {},
    });
    mutateRegions({
      countryId: 1,
    });
  }, []);

  const onChangePagination = ({ page, limit }, filters, sorter) => {
    let searchColumns = isEmpty(filters)
      ? pagination.searchColumns
      : [
        ...pagination.searchColumns,
        ...(filters?.groupName
          ? [
            {
              name: 'groupName',
              value: filters?.groupName,
            },
          ]
          : []),
        ...(filters?.groupNumber
          ? [
            {
              name: 'groupNumber',
              value: filters?.groupNumber,
            },
          ]
          : []),
      ];
    setPagination({
      ...pagination,
      pageNumber: page || pagination.pageNumber,
      pageSize: limit || pagination.pageSize,
      searchColumns,
    });
  };

  const toggle = () => {
    if (modal) {
      setModal(false);
      setGroup(null);
    } else {
      setModal(true);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
        accessor: '#',
        width: '20px',
        filterable: true,
        Cell: (cellProps) => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
      },
      {
        Header: 'ID',
        accessor: 'id',
        Cell: (cellProps) => {
          return <BillingName {...cellProps} />;
        },
      },
      {
        Header: 'NAME',
        accessor: 'name',
        filterable: true,
        Cell: (cellProps) => {
          return <BillingName {...cellProps} />;
        },
      },
      {
        Header: 'CONSTITUENCY',
        accessor: 'constituencyName',
        filterable: true,
        Cell: (cellProps) => {
          return <Total {...cellProps} />;
        },
      },
      {
        Header: 'COUNTY',
        accessor: 'countyName',
        filterable: true,
        Cell: (cellProps) => {
          return <Total {...cellProps} />;
        },
      },
    ],
    [],
  );

  const onSearch = (data) => {
    const searchColumns = [];
    if (isFacilitator) {
      searchColumns.push({ name: 'wardId', value: address?.wardId });
    }
    if (isSiteCord && data?.wardId) {
      searchColumns.push(data?.wardId);
    } else {
      if (
        (isClusterLeader ||
          isFinance ||
          isDirector ||
          isAdmin ||
          isSuperAdmin) &&
        data?.regionId
      ) {
        searchColumns.push(data?.regionId);
      }
      if (data.wardId) {
        searchColumns.push(data?.wardId);
      }
      if (data.constituencyId) {
        searchColumns.push(data?.constituencyId);
      }
      if (data.countyId) {
        searchColumns.push(data?.countyId);
      }
    }
    data?.startDate && searchColumns.push(data?.startDate);
    data?.endDate && searchColumns.push(data?.endDate);

    setPagination({ ...pagination, searchColumns });

    let add = {};
    searchColumns.forEach((a, i) => {
      add[a.name] = a.value;
    });
  };

  const handleDelete = async (id) => {
    await delApi('api/um/group?groupId=' + id);
    mutateGroups({ ...pagination, pageNumber: pagination.pageNumber - 1 });
  };

  const handdleCreate = async () => {
    validation.resetForm();
    setIsEdit(false);
    setModal(true);
  };
  const handleEdit = async (data) => {
    setModal(true);
    mutateWard(data?.id);
    setId(data?.id)
    setIsEdit(true);
  };

  useEffect(() => {
    if (id) mutateWard(id);
  }, [id]);

  useEffect(() => {
    if (ward?.constituencyId) {
      mutateConstituency(ward?.constituencyId);
    }
  }, [ward]);

  useEffect(() => {
    if (constituency?.countyId) {
      mutateCounty(constituency?.countyId);
      mutateConstituencies({
        countyId: constituency?.countyId,
      });
    }
  }, [constituency]);

  useEffect(() => {
    if (county?.regionId) {
      mutateRegion(county?.regionId);
      mutateCounties({
        regionId: county?.regionId,
      });
    }
  }, [county]);

  return (
    <React.Fragment>
      {/* <GroupsModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Groups" />
          <StatCards items={groupsCardData} md="4" />
          <Card>
            <CardBody className="pb-0">
              <MainFilter onSearch={onSearch} inlineActions />
            </CardBody>
          </Card>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    pageSizeAtBottom
                    columns={columns}
                    data={groupsData?.list?.reverse() || []}
                    isGlobalFilter={true}
                    isAddOptions={true}
                    hasCreate={true}
                    hasSearch
                    isPagination={true}
                    filterable={false}
                    iscustomPageSizeOptions={true}
                    showEdit={
                      isSuperAdmin
                    }
                    handleEdit={handleEdit}
                    showView={isSuperAdmin}
                    handleDelete={handleDelete}
                    showDelete={
                      isSuperAdmin
                    }
                    handleCreate={handdleCreate}
                    loading={isLoadingGroups}
                    pages={pages}
                    resource="ward"
                    addText="Add New Ward"
                    tableClass="align-middle table-nowrap table-check"
                    theadClass="table-light"
                    pagination="pagination pagination-rounded justify-content-end mb-2"
                    paginationData={pagination}
                    onChangePagination={onChangePagination}
                    searchByNames={[
                      {
                        value: 'groupName',
                        text: t('groups.groupName'),
                      },
                      {
                        value: 'groupNumber',
                        text: t('groups.groupNumber'),
                      },
                    ]}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? 'Edit Ward' : 'Add Ward'}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label>Ward Name</Label>
                      <Input
                        name="name"
                        type="text"
                        placeholder="Enter Ward Name"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ''}
                        invalid={
                          validation.touched.name &&
                            validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name &&
                        validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>Region</Label>
                      <SelectField
                        name="regionId"
                        onChange={(e) => {
                          validation.handleChange(e);
                          mutateCounties({ regionId: e.target.value });
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.regionId || ''}
                      >
                        <option value={''}>Select Region</option>
                        {
                          regions?.map(c => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                          ))
                        }
                      </SelectField>
                      {validation.touched.regionId &&
                        validation.errors.regionId ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.regionId}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>County</Label>
                      <SelectField
                        name="countyId"
                        onChange={(e) => {
                          validation.handleChange(e);
                          mutateConstituencies({ countyId: e.target.value });
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.countyId || ''}
                      >
                        <option value={''}>Select County</option>
                        {
                          counties?.map(c => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                          ))
                        }
                      </SelectField>
                      {validation.touched.countyId &&
                        validation.errors.countyId ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.countyId}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Constituency</Label>
                      <SelectField
                        name="constituencyId"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.constituencyId || ''}
                      >
                        <option value={''}>Select Constituency</option>
                        {
                          constituencies?.map(c => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                          ))
                        }
                      </SelectField>
                      {validation.touched.constituencyId &&
                        validation.errors.constituencyId ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.constituencyId}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
Group.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default Group;
